import API from "../../../services/API";
import Formatter from "../../../services/Formatter";

/**
 * CEO Circle of Excellence (Dashboard tab + HR add / edit / remove modal).
 * Every call goes through API.call so the JWT and X-Authorization headers are added for free.
 */

export const fetchCeoCircle = () => {
    return (dispatch, getState) => {
        return API.call({
            method: "get",
            url: "/ceo-circle",
        })
        .then(result => {
            dispatch({
                'type'  : 'FETCH_CEO_CIRCLE_SUCCESS',
                'list'  : result.data.content
            })
        })
        .catch(e => {
            dispatch( Formatter.alert_error( e ) )
            // Lets the tab replace its loading state with a short "couldn't load" line.
            dispatch({
                'type'  : 'FETCH_CEO_CIRCLE_FAILED'
            })
        });
    }
}

// Shared by create and update: the form shows a 422 on its own field, so no alert for
// validation failures; every other failure raises the standard alert. Always rethrows.
const saveFailed = (dispatch) => (e) => {
    if (!e || e.status !== 422) {
        dispatch( Formatter.alert_error( e ) )
    }
    throw e;
}

const saved = (dispatch) => (result) => {
    dispatch( Formatter.alert_success( result, 3000 ));
    dispatch({
        'type'  : 'CEO_CIRCLE_SAVED',
        'item'  : result.data.content
    })
    return result;
}

export const createCeoCircleAwardee = ( data ) => {
    return (dispatch, getState) => {
        return API.call({
            method: "post",
            url: "/ceo-circle",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: data
        })
        .then( saved(dispatch) )
        .catch( saveFailed(dispatch) );
    }
}

// POST (not PUT): PHP does not parse multipart bodies on PUT.
export const updateCeoCircleAwardee = ( id, data ) => {
    return (dispatch, getState) => {
        return API.call({
            method: "post",
            url: "/ceo-circle/" + id + "/update",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: data
        })
        .then( saved(dispatch) )
        .catch( saveFailed(dispatch) );
    }
}

export const deleteCeoCircleAwardee = ( id ) => {
    return (dispatch, getState) => {
        return API.call({
            method: "delete",
            url: "/ceo-circle/" + id,
        })
        .then(result => {
            dispatch( Formatter.alert_success( result, 3000 ));
            dispatch({
                'type'  : 'CEO_CIRCLE_DELETED',
                'id'    : id
            })
        })
        .catch(e => {
            dispatch( Formatter.alert_error( e ) )
        });
    }
}

// Employee picker. Resolves to the list; a failed search (e.g. the 422 for a short q)
// resolves to [] so the picker just shows "no match". Nothing is dispatched.
export const searchCeoCircleEmployees = ( q ) => {
    return (dispatch, getState) => {
        return API.call({
            method: "get",
            url: "/ceo-circle/employees",
            params: { q: q }
        })
        .then(result => result.data.content)
        .catch(() => []);
    }
}

// "Fetch from BHR" preview. Resolves to the data: URI; rejects (404) when BHR has nothing.
export const fetchCeoCircleBhrPhoto = ( userId ) => {
    return (dispatch, getState) => {
        return API.call({
            method: "get",
            url: "/ceo-circle/bhr-photo/" + userId,
        })
        .then(result => result.data.content.photo);
    }
}
